import { Budget } from 'types/executiveStatistics'
import AgencyService from 'services/agenciesService'

const setBudgetStatistics = async ({
  budgetData,
  getAuthToken,
}: {
  budgetData: Budget[]
  getAuthToken: () => Promise<string>
}): Promise<void> => {
  const token = await getAuthToken()
  const service = new AgencyService(token)

  await service.agencyService.put('SetExecutiveKeyBudget', budgetData)
}

export default setBudgetStatistics
